export const tag = ({ theme: { colors } }) => ({
    alignItems: 'center',
    borderRadius: '2px',
    fontSize: '14px',
    padding: '.2em 1em',
});
